const s = "_section_b946n_1", t = {
  section: s
};
export {
  t as default,
  s as section
};
